module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.c43d913e.woff2";